<template>
  <v-card class="mainCard">
    <v-toolbar :height="5" dark color="cyan">
      <template v-slot:extension>
        <v-tabs v-model="tab" align-with-title>
          <v-tabs-slider color="white"></v-tabs-slider>
          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-flex class="signUp_container">
            <div class="signUp_form">
              <div class="signUp_form-title mb-2">
                Tryout Registration / Club Pre-Registration for club with club ID
                {{ this.clubId }}
              </div>
              <!--{{ this.$route.query.clubId }}-->
              <transition name="fade">
                <!-- Error Alert -->
                <form-alert
                  style="width: 95%"
                  v-if="error"
                  :message="error.message"
                ></form-alert>
              </transition>
              <v-form
                v-model="isFormValid"
                lazy-validation
                ref="form"
                @submit.prevent="addNewAthlete"
                class="signUp_form-flex"
              >
                <v-container grid-list-md>
                  <athlete_form
                    v-bind:hidePhoto="true"
                    v-bind:hideLang="true"
                    v-bind:hideCountry="true"
                    v-bind:hideStatus="true"
                    v-bind:StatusInactive="true"
                    v-bind:showPhone="true"
                    v-bind:info="true"
                    v-bind:hideTeam="true"
                    v-bind:teamName="'TRYOUT'"
                    v-bind:teamId="null"
                    v-bind:dark="true"
                    v-bind:additionalInfo="true"
                    @childData="handleChildData"
                  ></athlete_form>
                </v-container>
                <div style="color: white" class="termsStyle">
                  <div
                    v-for="(clubForm, index) in clubForms"
                    :key="clubForm.id"
                    v-if="index === 0"
                  >
                    <p>
                      <a
                        target="_blank"
                        v-bind:href="'https://drive.google.com/file/d/1_Mt0nM4msbtnc38AB07_f92qUSh5N3l9/view?usp=sharing'"
                      >
                        Waiver Of Liability
                      </a>
                      {{ clubForm.waiverOfLiability }}
                    </p>
                  </div>
                </div>
                <v-checkbox
                  dark
                  id="checkboxOG"
                  style="align-self: flex-start"
                  v-model="privacyPolicy"
                  :rules="requiredRule"
                  label="Agree to terms and conditions"
                ></v-checkbox>
                <v-btn
                  outlined
                  color="white"
                  :disabled="!isFormValid || loading"
                  type="submit"
                  style="width: 100%"
                  :loading="loading"
                  data-cy="signUpButton"
                >
                  Register
                </v-btn>
              </v-form>
            </div>
          </v-flex>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-flex class="signUp_container">
            <div class="signUp_form">
              <div class="signUp_form-title mb-2">
                Club Program Registration
              </div>
              <transition name="fade">
                <form-alert
                  style="width: 95%"
                  v-if="error"
                  :message="error.message"
                ></form-alert>
              </transition>
              <div class="full-width-container">
                <Club_program_register />
              </div>
            </div>
          </v-flex>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-spacer></v-spacer>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationRules } from "../../../constants/global";
import Club_program_register from "../../shared/club_program_register.vue";
import athlete_form from "../../shared/athlete_form.vue";

export default {
  data() {
    return {
      showPass: false,
      showConfirmPass: false,
      menu: false,
      userEmail: "",
      birthDate: "",
      privacyPolicy: false,
      isFormValid: true,
      tab: null,
      items: ["Tryout Registration"],
      loading: false,
      //error: null,
      formData: {},
      requiredRule: [(v) => !!v || "Value is required"],
    };
  },
  created() {
    //console.log("111this.$route.query111");
    console.log(this.$route.query);
    if (!(Object.entries(this.$route.query).length === 0)) {
      const { clubId } = this.$route.query;
      this.clubId = clubId;
      // this.tab = this.categoryList.edges.findIndex((item) => item.node.catName == tab);
    }
  },

  computed: {
    ...mapGetters([
      "loading",
      "error",
      "user",
      "allClubFormData",
      "usersList",
      "club",
    ]),
    clubForms() {
      return this.allClubFormData;
    },
  },
  mounted() {
    console.log(this.$route.query.clubId);
  },
  methods: {
    ...mapActions(["allClubFormData", "addUpdateAthlete"]),
    handleChildData(data) {
      this.formData = data;
    },
    addNewAthlete() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const birthDate = new Date(this.formData.birthDate);
        const formattedBirthDate = birthDate.toISOString().split("T")[0];

        // Call the Vuex action
        this.addUpdateAthlete({
          athleteData: {
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            email: this.formData.email,
            status: this.formData.status,
            birthDate: formattedBirthDate,
            photo: this.formData.photo,
            phone: this.formData.phone,
            sourceOfInformation: this.formData.info,
            gender: this.formData.gender,
            teamId: null,
            language: this.formData.language,
            country: this.formData.country,
            createDate: this.moment.format("YYYY-MM-DD"),
            clubId: this.$route.query.clubId,
            startMembership: this.moment.format("YYYY-MM-DD"),
            additionalInfo: this.formData.additionalInfo,
            updateSource: this.formData.email,
          },
        })
          .then(() => {
            try {
              this.loading = false;
              console.log("Success: Athlete added");
              this.$toast.success(
                `Athlete ${this.formData.firstName} ${this.formData.lastName} has been added for tryout, we will contact you on next steps.`,
                { position: "bottom-center", duration: 30000 }
              );
              this.$refs.form.reset(); // Reset the form after success
            } catch (err) {
              console.error("Error during success handling:", err);
              this.$toast.error(
                "An unexpected error occurred during success handling.",
                {
                  position: "bottom-center",
                  duration: 30000,
                }
              );
            }
          })
          .catch((err) => {
            try {
              // Handle the error properly
              this.loading = false;
              console.error("Error caught:", err); // Log the error
              this.$toast.error(`An error occurred: ${err.message || err}`, {
                position: "bottom-center",
                duration: 30000,
              });
            } catch (catchErr) {
              console.error("Error during error handling:", catchErr);
              this.$toast.error(
                "An unexpected error occurred while handling the error.",
                {
                  position: "bottom-center",
                  duration: 30000,
                }
              );
            }
          });
      }
    },
    // addNewAthleteOld() {
    //   if (this.$refs.form.validate()) {
    //     this.loading = true;
    //     const birthDate = new Date(this.formData.birthDate);
    //     const formattedBirthDate = birthDate.toISOString().split("T")[0];
    //     this.addUpdateAthlete({
    //       athleteData: {
    //         firstName: this.formData.firstName,
    //         lastName: this.formData.lastName,
    //         email: this.formData.email,
    //         status: this.formData.status,
    //         birthDate: formattedBirthDate,
    //         photo: this.formData.photo,
    //         phone: this.formData.phone,
    //         sourceOfInformation: this.formData.info,
    //         gender: this.formData.gender,
    //         teamId: null,
    //         language: this.formData.language,
    //         country: this.formData.country,
    //         createDate: this.moment.format("YYYY-MM-DD"),
    //         //clubId: this.$store.getters.club,
    //         clubId: null,
    //         startMembership: this.moment.format("YYYY-MM-DD"),
    //         additionalInfo: this.formData.additionalInfo,
    //         updateSource: "Tryout Form",
    //       },
    //     }).catch((error) => {
    //       this.error = {
    //         message:
    //           (error.response &&
    //             error.response.data &&
    //             error.response.data.message) ||
    //           "An error occurred while adding the athlete. Please try again.",
    //       };
    //       this.loading = false;
    //       console.error("this.error");
    //       console.error(this.error);
    //     });
    //   }
    // },
    handleGetClubFormData() {
      this.clubId = this.$route.query.clubId;
      this.$store.dispatch("allClubFormData", {
        clubId: this.clubId,
      });
    },
  },
  created() {
    this.handleGetClubFormData();
  },
  components: { Club_program_register, athlete_form },
};
</script>

<style lang="scss">
.v-toolbar__content {
  display: none;
}

h2 {
  color: white;
}

.full-width-container {
  width: 100%;
}

.name-container {
  display: flex;
}

.name-heading {
  flex-basis: 40%;
  align-self: flex-start;
  display: flex;
  align-items: flex-end;
  margin-top: 0.5rem;
  color: white;
}

.name-text-field {
  flex-basis: 60%;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.typed_text {
  font-size: 30px;
  font-weight: 900;
  font-family: "Roboto";
  font-style: italic;
  color: white;
  text-transform: uppercase;
}

.typed_text::before {
  content: attr(filter-content);
  filter: url(#motion-blur-filter);
}

svg {
  display: none;
}

.termsStyle {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: -webkit-fill-available;
}

.signUp {
  width: 100%;
  height: 100%;
  background-image: url("../../../../public/assets/img/pool-wallpaper-12.jpeg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_container {
    height: 100%;
    background-color: #186490;
    display: flex;
    align-items: center;
    opacity: 0.9;
    border-left: 1px solid white;
  }

  &_form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 100%;
    padding: 5% 2.5%;
    margin: 0 auto;
  }

  &_form-confirm-rule {
    color: white;

    a {
      color: black;
      text-decoration: none;
    }
  }

  &_form-title {
    font-size: 40px;
    font-weight: bold;
    color: white;
    align-self: flex-start;
    margin-left: 2.5%;
    font-family: "Roboto";
  }

  &_form-flex {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    /* Change the white to any color */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-text-fill-color: white;
      -webkit-box-shadow: 0 0 0 30px #0277bd inset !important;
    }

    input:focus,
    input:active {
      color: white !important;
    }
  }

  .marR {
    margin-right: 1rem;
  }

  &_form-email {
    width: 100%;
  }

  &_form-pass {
    width: 100%;
  }
}

.mainCard {
  margin-bottom: 2rem;
}

.signUp_form-title2 {
  color: rgba(0, 0, 0, 0.687);
}

.helper_text {
  color: white;
  font-weight: normal;
  margin: 10px auto;

  a {
    color: white;
    padding-left: 10px;
    margin-left: 10px;
    text-decoration: none;
    border-left: 1px solid white;
    transition: all 0.1s;
  }

  a:hover {
    text-shadow: 0 0 1px white;
    border: 1px solid white;
    padding: 3px 8px;
  }
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 1264px) {
  .signUp {
    justify-content: flex-end;
  }
}

.custom-toast {
  font-size: 1rem;
  color: #ffffff;
  background-color: #00796b;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #004d40;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
}

@media only screen and (max-width: 599px) {
  .signUp_container {
    border: none;
  }
}
</style>
